/** @import modules */

import { createContext } from "react";

/** @create context */

export const CompareContext = createContext ( null );